/**
 * The UnlikelyAI mark and the pill it sits in.
 *
 * Both are fixed magenta rather than the brand colour. Magenta means "UnlikelyAI
 * produced this", so it must not follow the tenant palette.
 */
import { UnlikelyAILogo } from "@targeted-support/ui/components/icons";
import { cn } from "@unlikelyai-magic/utils";

export const UNLIKELY_MAGENTA = "#B11082";

/**
 * The UnlikelyAI mark, always in magenta.
 */
export const UnlikelyMark = ({ size = 0.75 }: { size?: number }) => (
  <UnlikelyAILogo size={size} fill={UNLIKELY_MAGENTA} />
);

/**
 * A small pill reading "UnlikelyAI", used on any panel showing our output.
 */
export const UnlikelyBadge = ({ className }: { className?: string }) => (
  <span
    className={cn(
      "inline-flex items-center gap-1.5 rounded-full border border-unlikely/25 bg-unlikely/[0.08] px-2 py-0.5",
      className
    )}
  >
    <UnlikelyMark size={0.625} />
    <span className="text-[10px] font-semibold leading-none text-unlikely">
      UnlikelyAI
    </span>
  </span>
);
